import React, { Component, PropTypes } from 'react';
import Image from '../../components/image/image';
import Video from '../../components/image/video';
import classnames from 'classnames';
import css from './threeimages.scss';

export default class ThreeImages extends Component {
	static propTypes = {};
	constructor(props) {
		super(props);
	}

	render() {
		const classNames = classnames({
			'span14': true,
			'three-images': true,
		}, this.props.className);

		const sizeSettings = {
			containerSmallClass: 'three-images__container__small span14-mobile span5-tablet span5-desktop',
			imageSmallClass: 'three-images__image',
			imageSmallSpan: (this.props.browser.window.width > 720) ? 'span5' : 'span14',
			containerLargeClass: 'three-images__container__large span14-mobile span9-tablet span9-desktop',
			imageLargeClass: 'three-images__image',
			imageLargeSpan: (this.props.browser.window.width > 720) ? 'span9' : 'span14',
		};

		const component1 = {
			component: this.props.video1 ? Video : Image,
			props: this.getProps(this.props.video1, this.props.imgone, true, sizeSettings),
		};

		const component2 = {
			component: this.props.video2 ? Video : Image,
			props: this.getProps(this.props.video2, this.props.imgtwo, true, sizeSettings),
		};

		const component3 = {
			component: this.props.video3 ? Video : Image,
			props: this.getProps(this.props.video3, this.props.imgthree, false, sizeSettings),
		};

		return (
			<div className={classNames}>
				<div className="three-images__container">
					<div className={sizeSettings.containerSmallClass}>
						{this.getComponent(component1)}
						{this.getComponent(component2)}
					</div>
					<div className={sizeSettings.containerLargeClass}>
						{this.getComponent(component3)}
					</div>
				</div>
			</div>
		);
	}

	getProps(video, img, isSmall, settings) {
		if (video) {
			return {
				video,
				className: isSmall ? settings.imageSmallClass : settings.imageLargeClass,
			}
		}

		return {
			img,
			className: isSmall ? settings.imageSmallClass : settings.imageLargeClass,
			span: isSmall ? settings.imageSmallSpan : settings.imageLargeSpan,
			alt: '',
			browser: this.props.browser,
		}
	}

	getComponent(comp) {
		if (comp.component && comp.props) {
			const Component = comp.component;
			return <Component {...comp.props} />
		}

		return false;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/threeimages/threeimages.js
 **/